var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9834 53.5506L8.10446 24.4237C8.10446 22.9467 8.8066 21.5426 9.96877 20.6225L26.917 7.42705C28.6603 6.07119 31.1057 6.07119 32.8731 7.42705L49.8214 20.5983C51.0078 21.5183 51.6857 22.9225 51.6857 24.4237V53.5506",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9834 53.5506L8.10446 24.4237C8.10446 22.9467 8.8066 21.5426 9.96877 20.6225L26.917 7.42705C28.6603 6.07119 31.1057 6.07119 32.8732 7.42705L49.8214 20.5983C51.0078 21.5183 51.6857 22.9225 51.6857 24.4237V53.5506",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68311 53.5508H54.1068",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3162 41.4453H27.4738C25.4642 41.4453 23.842 43.0675 23.842 45.0771V53.5512H35.948V45.0771C35.948 43.0675 34.3258 41.4453 32.3162 41.4453Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8422 33.5757H18.9998C17.6681 33.5757 16.5786 32.4862 16.5786 31.1545V27.5227C16.5786 26.1911 17.6681 25.1016 18.9998 25.1016H23.8422C25.1738 25.1016 26.2633 26.1911 26.2633 27.5227V31.1545C26.2633 32.4862 25.1738 33.5757 23.8422 33.5757Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7904 33.5757H35.948C34.6164 33.5757 33.5269 32.4862 33.5269 31.1545V27.5227C33.5269 26.1911 34.6164 25.1016 35.948 25.1016H40.7904C42.1221 25.1016 43.2116 26.1911 43.2116 27.5227V31.1545C43.2116 32.4862 42.1221 33.5757 40.7904 33.5757Z",
    fill: "white",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8433 17.2323L46.7706 9.96875H36.1174",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8433 17.2323L46.7706 9.96875H36.1174",
    stroke: "current",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.e3ccfb614b2ff3f47b9f4d190515e475.svg";
export { ForwardRef as ReactComponent };